var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var BLOCK_LENGTH = 1 << 14;

var Piece = /*#__PURE__*/function () {
  "use strict";

  function Piece(length) {
    _classCallCheck(this, Piece);

    this.length = length;
    this.missing = length;
    this.sources = null;
    this._chunks = Math.ceil(length / BLOCK_LENGTH);
    this._remainder = length % BLOCK_LENGTH || BLOCK_LENGTH;
    this._buffered = 0;
    this._buffer = null;
    this._cancellations = null;
    this._reservations = 0;
    this._flushed = false;
  }

  _createClass(Piece, [{
    key: "chunkLength",
    value: function chunkLength(i) {
      return i === this._chunks - 1 ? this._remainder : BLOCK_LENGTH;
    }
  }, {
    key: "chunkLengthRemaining",
    value: function chunkLengthRemaining(i) {
      return this.length - i * BLOCK_LENGTH;
    }
  }, {
    key: "chunkOffset",
    value: function chunkOffset(i) {
      return i * BLOCK_LENGTH;
    }
  }, {
    key: "reserve",
    value: function reserve() {
      if (!this.init()) return -1;
      if (this._cancellations.length) return this._cancellations.pop();
      if (this._reservations < this._chunks) return this._reservations++;
      return -1;
    }
  }, {
    key: "reserveRemaining",
    value: function reserveRemaining() {
      if (!this.init()) return -1;

      if (this._reservations < this._chunks) {
        var min = this._reservations;
        this._reservations = this._chunks;
        return min;
      }

      return -1;
    }
  }, {
    key: "cancel",
    value: function cancel(i) {
      if (!this.init()) return;

      this._cancellations.push(i);
    }
  }, {
    key: "cancelRemaining",
    value: function cancelRemaining(i) {
      if (!this.init()) return;
      this._reservations = i;
    }
  }, {
    key: "get",
    value: function get(i) {
      if (!this.init()) return null;
      return this._buffer[i];
    }
  }, {
    key: "set",
    value: function set(i, data, source) {
      if (!this.init()) return false;
      var len = data.length;
      var blocks = Math.ceil(len / BLOCK_LENGTH);

      for (var j = 0; j < blocks; j++) {
        if (!this._buffer[i + j]) {
          var offset = j * BLOCK_LENGTH;
          var splitData = data.slice(offset, offset + BLOCK_LENGTH);
          this._buffered++;
          this._buffer[i + j] = splitData;
          this.missing -= splitData.length;

          if (!this.sources.includes(source)) {
            this.sources.push(source);
          }
        }
      }

      return this._buffered === this._chunks;
    }
  }, {
    key: "flush",
    value: function flush() {
      if (!this._buffer || this._chunks !== this._buffered) return null;
      var buffer = Buffer.concat(this._buffer, this.length);
      this._buffer = null;
      this._cancellations = null;
      this.sources = null;
      this._flushed = true;
      return buffer;
    }
  }, {
    key: "init",
    value: function init() {
      if (this._flushed) return false;
      if (this._buffer) return true;
      this._buffer = new Array(this._chunks);
      this._cancellations = [];
      this.sources = [];
      return true;
    }
  }]);

  return Piece;
}();

Object.defineProperty(Piece, 'BLOCK_LENGTH', {
  value: BLOCK_LENGTH
});
module.exports = Piece;